export const FETCH_TRIPS_REQUEST = 'FETCH_TRIPS_REQUEST';
export const FETCH_TRIPS_SUCCESS = 'FETCH_TRIPS_SUCCESS';
export const FETCH_TRIPS_FAILURE = 'FETCH_TRIPS_FAILURE';

export const FETCH_TRIPS_POLICIES_REQUEST = 'FETCH_TRIPS_POLICIES_REQUEST';
export const FETCH_TRIPS_POLICIES_SUCCESS = 'FETCH_TRIPS_POLICIES_SUCCESS';
export const FETCH_TRIPS_POLICIES_FAILURE = 'FETCH_TRIPS_POLICIES_FAILURE';

export const FETCH_TRIPS_CLAIMS_REQUEST = 'FETCH_TRIPS_CLAIMS_REQUEST';
export const FETCH_TRIPS_CLAIMS_SUCCESS = 'FETCH_TRIPS_CLAIMS_SUCCESS';
export const FETCH_TRIPS_CLAIMS_FAILURE = 'FETCH_TRIPS_CLAIMS_FAILURE';

export const FETCH_TRIPS_CLAIMS_TODAY_REQUEST = 'FETCH_TRIPS_CLAIMS_TODAY_REQUEST';
export const FETCH_TRIPS_CLAIMS_TODAY_SUCCESS = 'FETCH_TRIPS_CLAIMS_TODAY_SUCCESS';
export const FETCH_TRIPS_CLAIMS_TODAY_FAILURE = 'FETCH_TRIPS_CLAIMS_TODAY_FAILURE';

export const FETCH_TRIPS_CHECK_CLAIMS_REQUEST = 'FETCH_TRIPS_CHECK_CLAIMS_REQUEST';
export const FETCH_TRIPS_CHECK_CLAIMS_SUCCESS = 'FETCH_TRIPS_CHECK_CLAIMS_SUCCESS';
export const FETCH_TRIPS_CHECK_CLAIMS_FAILURE = 'FETCH_TRIPS_CHECK_CLAIMS_FAILURE';

export const FETCH_TRIPS_FORECASTS_REQUEST = 'FETCH_TRIPS_FORECASTS_REQUEST';
export const FETCH_TRIPS_FORECASTS_SUCCESS = 'FETCH_TRIPS_FORECASTS_SUCCESS';
export const FETCH_TRIPS_FORECASTS_FAILURE = 'FETCH_TRIPS_FORECASTS_FAILURE';

export const FETCH_TRIPS_SUBCOVERAGES_REQUEST = 'FETCH_TRIPS_SUBCOVERAGES_REQUEST';
export const FETCH_TRIPS_SUBCOVERAGES_SUCCESS = 'FETCH_TRIPS_SUBCOVERAGES_SUCCESS';
export const FETCH_TRIPS_SUBCOVERAGES_FAILURE = 'FETCH_TRIPS_SUBCOVERAGES_FAILURE';

export const FETCH_TRIPS_OBSERVATIONS_REQUEST = 'FETCH_TRIPS_OBSERVATIONS_REQUEST';
export const FETCH_TRIPS_OBSERVATIONS_SUCCESS = 'FETCH_TRIPS_OBSERVATIONS_SUCCESS';
export const FETCH_TRIPS_OBSERVATIONS_FAILURE = 'FETCH_TRIPS_OBSERVATIONS_FAILURE';

export const FETCH_TRIP_OBSERVATION_REQUEST = 'FETCH_TRIP_OBSERVATION_REQUEST';
export const FETCH_TRIP_OBSERVATION_SUCCESS = 'FETCH_TRIP_OBSERVATION_SUCCESS';
export const FETCH_TRIP_OBSERVATION_FAILURE = 'FETCH_TRIP_OBSERVATION_FAILURE';

export const fetchTripsRequest = (params = {}) => ({ type: FETCH_TRIPS_REQUEST, payload: params });
export const fetchTripsSuccess = (data) => ({ type: FETCH_TRIPS_SUCCESS, payload: data });
export const fetchTripsFailure = (error) => ({ type: FETCH_TRIPS_FAILURE, payload: error });

export const fetchTripsPoliciesRequest = (params = {}) => ({ type: FETCH_TRIPS_POLICIES_REQUEST, payload: params });
export const fetchTripsPoliciesSuccess = (data) => ({ type: FETCH_TRIPS_POLICIES_SUCCESS, payload: data });
export const fetchTripsPoliciesFailure = (error) => ({ type: FETCH_TRIPS_POLICIES_FAILURE, payload: error });

export const fetchTripsClaimsRequest = (params = {}) => ({ type: FETCH_TRIPS_CLAIMS_REQUEST, payload: params });
export const fetchTripsClaimsSuccess = (data) => ({ type: FETCH_TRIPS_CLAIMS_SUCCESS, payload: data });
export const fetchTripsClaimsFailure = (error) => ({ type: FETCH_TRIPS_CLAIMS_FAILURE, payload: error });

export const fetchTripsClaimsTodayRequest = (params = {}) => ({ type: FETCH_TRIPS_CLAIMS_TODAY_REQUEST, payload: params });
export const fetchTripsClaimsTodaySuccess = (data) => ({ type: FETCH_TRIPS_CLAIMS_TODAY_SUCCESS, payload: data });
export const fetchTripsClaimsTodayFailure = (error) => ({ type: FETCH_TRIPS_CLAIMS_TODAY_FAILURE, payload: error });

export const fetchTripsCheckClaimsRequest = (params = {}) => ({ type: FETCH_TRIPS_CHECK_CLAIMS_REQUEST, payload: params });
export const fetchTripsCheckClaimsSuccess = (data) => ({ type: FETCH_TRIPS_CHECK_CLAIMS_SUCCESS, payload: data });
export const fetchTripsCheckClaimsFailure = (error) => ({ type: FETCH_TRIPS_CHECK_CLAIMS_FAILURE, payload: error });

export const fetchTripsForecastsRequest = (params = {}) => ({ type: FETCH_TRIPS_FORECASTS_REQUEST, payload: params });
export const fetchTripsForecastsSuccess = (data) => ({ type: FETCH_TRIPS_FORECASTS_SUCCESS, payload: data });
export const fetchTripsForecastsFailure = (error) => ({ type: FETCH_TRIPS_FORECASTS_FAILURE, payload: error });

export const fetchTripsSubcoveragesRequest = (params = {}) => ({ type: FETCH_TRIPS_SUBCOVERAGES_REQUEST, payload: params });
export const fetchTripsSubcoveragesSuccess = (data) => ({ type: FETCH_TRIPS_SUBCOVERAGES_SUCCESS, payload: data });
export const fetchTripsSubcoveragesFailure = (error) => ({ type: FETCH_TRIPS_SUBCOVERAGES_FAILURE, payload: error });

export const fetchTripsObservationsRequest = (params = {}) => ({ type: FETCH_TRIPS_OBSERVATIONS_REQUEST, payload: params });
export const fetchTripsObservationsSuccess = (data) => ({ type: FETCH_TRIPS_OBSERVATIONS_SUCCESS, payload: data });
export const fetchTripsObservationsFailure = (error) => ({ type: FETCH_TRIPS_OBSERVATIONS_FAILURE, payload: error });

export const fetchTripObservationRequest = (observationId) => ({ type: FETCH_TRIP_OBSERVATION_REQUEST, payload: observationId });
export const fetchTripObservationSuccess = (data) => ({ type: FETCH_TRIP_OBSERVATION_SUCCESS, payload: data });
export const fetchTripObservationFailure = (error) => ({ type: FETCH_TRIP_OBSERVATION_FAILURE, payload: error });

export const FETCH_TRIP_SUBCOVERAGE_BY_ID_REQUEST = 'FETCH_TRIP_SUBCOVERAGE_BY_ID_REQUEST';
export const FETCH_TRIP_SUBCOVERAGE_BY_ID_SUCCESS = 'FETCH_TRIP_SUBCOVERAGE_BY_ID_SUCCESS';
export const FETCH_TRIP_SUBCOVERAGE_BY_ID_FAILURE = 'FETCH_TRIP_SUBCOVERAGE_BY_ID_FAILURE';

export const fetchTripSubcoverageByIdRequest = (subcoverageTripId) => ({ type: FETCH_TRIP_SUBCOVERAGE_BY_ID_REQUEST, payload: subcoverageTripId });
export const fetchTripSubcoverageByIdSuccess = (data) => ({ type: FETCH_TRIP_SUBCOVERAGE_BY_ID_SUCCESS, payload: data });
export const fetchTripSubcoverageByIdFailure = (error) => ({ type: FETCH_TRIP_SUBCOVERAGE_BY_ID_FAILURE, payload: error });

export const FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_REQUEST = 'FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_REQUEST';
export const FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_SUCCESS = 'FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_SUCCESS';
export const FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_FAILURE = 'FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_FAILURE';

export const fetchTripsForecastsNotTriggeredRequest = (params = {}) => ({ type: FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_REQUEST, payload: params });
export const fetchTripsForecastsNotTriggeredSuccess = (data) => ({ type: FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_SUCCESS, payload: data });
export const fetchTripsForecastsNotTriggeredFailure = (error) => ({ type: FETCH_TRIPS_FORECASTS_NOT_TRIGGERED_FAILURE, payload: error });

export const FETCH_FORECAST_NOT_TRIGGERED_BY_ID_REQUEST = 'FETCH_FORECAST_NOT_TRIGGERED_BY_ID_REQUEST';
export const FETCH_FORECAST_NOT_TRIGGERED_BY_ID_SUCCESS = 'FETCH_FORECAST_NOT_TRIGGERED_BY_ID_SUCCESS';
export const FETCH_FORECAST_NOT_TRIGGERED_BY_ID_FAILURE = 'FETCH_FORECAST_NOT_TRIGGERED_BY_ID_FAILURE';

export const fetchForecastNotTriggeredByIdRequest = (forecastNotTriggeredId) => ({ type: FETCH_FORECAST_NOT_TRIGGERED_BY_ID_REQUEST, payload: forecastNotTriggeredId });
export const fetchForecastNotTriggeredByIdSuccess = (data) => ({ type: FETCH_FORECAST_NOT_TRIGGERED_BY_ID_SUCCESS, payload: data });
export const fetchForecastNotTriggeredByIdFailure = (error) => ({ type: FETCH_FORECAST_NOT_TRIGGERED_BY_ID_FAILURE, payload: error });

export const FETCH_TRIP_BY_ID_REQUEST = 'FETCH_TRIP_BY_ID_REQUEST';
export const FETCH_TRIP_BY_ID_SUCCESS = 'FETCH_TRIP_BY_ID_SUCCESS';
export const FETCH_TRIP_BY_ID_FAILURE = 'FETCH_TRIP_BY_ID_FAILURE';

export const fetchTripByIdRequest = (tripId) => ({ type: FETCH_TRIP_BY_ID_REQUEST, payload: tripId });
export const fetchTripByIdSuccess = (data) => ({ type: FETCH_TRIP_BY_ID_SUCCESS, payload: data });
export const fetchTripByIdFailure = (error) => ({ type: FETCH_TRIP_BY_ID_FAILURE, payload: error });

export const CREATE_TRIP_REQUEST = 'CREATE_TRIP_REQUEST';
export const CREATE_TRIP_SUCCESS = 'CREATE_TRIP_SUCCESS';
export const CREATE_TRIP_FAILURE = 'CREATE_TRIP_FAILURE';

export const createTripRequest = (partnerId, tripData) => ({ type: CREATE_TRIP_REQUEST, payload: { partnerId, tripData } });
export const createTripSuccess = (data) => ({ type: CREATE_TRIP_SUCCESS, payload: data });
export const createTripFailure = (error) => ({ type: CREATE_TRIP_FAILURE, payload: error });

export const CREATE_SUBCOVERAGES_TRIP_REQUEST = 'CREATE_SUBCOVERAGES_TRIP_REQUEST';
export const CREATE_SUBCOVERAGES_TRIP_SUCCESS = 'CREATE_SUBCOVERAGES_TRIP_SUCCESS';
export const CREATE_SUBCOVERAGES_TRIP_FAILURE = 'CREATE_SUBCOVERAGES_TRIP_FAILURE';

export const createSubcoveragesTripRequest = (partnerId, subcoveragesData) => ({ type: CREATE_SUBCOVERAGES_TRIP_REQUEST, payload: { partnerId, subcoveragesData } });
export const createSubcoveragesTripSuccess = (data) => ({ type: CREATE_SUBCOVERAGES_TRIP_SUCCESS, payload: data });
export const createSubcoveragesTripFailure = (error) => ({ type: CREATE_SUBCOVERAGES_TRIP_FAILURE, payload: error });

export const FETCH_SUBCOVERAGES_BY_PARTNER_REQUEST = 'FETCH_SUBCOVERAGES_BY_PARTNER_REQUEST';
export const FETCH_SUBCOVERAGES_BY_PARTNER_SUCCESS = 'FETCH_SUBCOVERAGES_BY_PARTNER_SUCCESS';
export const FETCH_SUBCOVERAGES_BY_PARTNER_FAILURE = 'FETCH_SUBCOVERAGES_BY_PARTNER_FAILURE';

export const fetchSubcoveragesByPartnerRequest = (partnerId) => ({ type: FETCH_SUBCOVERAGES_BY_PARTNER_REQUEST, payload: partnerId });
export const fetchSubcoveragesByPartnerSuccess = (data) => ({ type: FETCH_SUBCOVERAGES_BY_PARTNER_SUCCESS, payload: data });
export const fetchSubcoveragesByPartnerFailure = (error) => ({ type: FETCH_SUBCOVERAGES_BY_PARTNER_FAILURE, payload: error });

export const UPDATE_TRIP_REQUEST = 'UPDATE_TRIP_REQUEST';
export const UPDATE_TRIP_SUCCESS = 'UPDATE_TRIP_SUCCESS';
export const UPDATE_TRIP_FAILURE = 'UPDATE_TRIP_FAILURE';

export const updateTripRequest = (tripId, tripData) => ({ type: UPDATE_TRIP_REQUEST, payload: { tripId, tripData } });
export const updateTripSuccess = (data) => ({ type: UPDATE_TRIP_SUCCESS, payload: data });
export const updateTripFailure = (error) => ({ type: UPDATE_TRIP_FAILURE, payload: error });

export const DELETE_TRIP_REQUEST = 'DELETE_TRIP_REQUEST';
export const DELETE_TRIP_SUCCESS = 'DELETE_TRIP_SUCCESS';
export const DELETE_TRIP_FAILURE = 'DELETE_TRIP_FAILURE';

export const deleteTripRequest = (tripId) => ({ type: DELETE_TRIP_REQUEST, payload: tripId });
export const deleteTripSuccess = () => ({ type: DELETE_TRIP_SUCCESS });
export const deleteTripFailure = (error) => ({ type: DELETE_TRIP_FAILURE, payload: error });

export const FETCH_TRIP_POLICY_BY_ID_REQUEST = 'FETCH_TRIP_POLICY_BY_ID_REQUEST';
export const FETCH_TRIP_POLICY_BY_ID_SUCCESS = 'FETCH_TRIP_POLICY_BY_ID_SUCCESS';
export const FETCH_TRIP_POLICY_BY_ID_FAILURE = 'FETCH_TRIP_POLICY_BY_ID_FAILURE';

export const fetchTripPolicyByIdRequest = (policyId) => ({ type: FETCH_TRIP_POLICY_BY_ID_REQUEST, payload: policyId });
export const fetchTripPolicyByIdSuccess = (data) => ({ type: FETCH_TRIP_POLICY_BY_ID_SUCCESS, payload: data });
export const fetchTripPolicyByIdFailure = (error) => ({ type: FETCH_TRIP_POLICY_BY_ID_FAILURE, payload: error });

export const CHANGE_POLICY_STATUS_REQUEST = 'CHANGE_POLICY_STATUS_REQUEST';
export const CHANGE_POLICY_STATUS_SUCCESS = 'CHANGE_POLICY_STATUS_SUCCESS';
export const CHANGE_POLICY_STATUS_FAILURE = 'CHANGE_POLICY_STATUS_FAILURE';

export const changePolicyStatusRequest = (policyId, status) => ({ type: CHANGE_POLICY_STATUS_REQUEST, payload: { policyId, status } });
export const changePolicyStatusSuccess = (data) => ({ type: CHANGE_POLICY_STATUS_SUCCESS, payload: data });
export const changePolicyStatusFailure = (error) => ({ type: CHANGE_POLICY_STATUS_FAILURE, payload: error });

export const UPDATE_TRIP_SUBCOVERAGE_REQUEST = 'UPDATE_TRIP_SUBCOVERAGE_REQUEST';
export const UPDATE_TRIP_SUBCOVERAGE_SUCCESS = 'UPDATE_TRIP_SUBCOVERAGE_SUCCESS';
export const UPDATE_TRIP_SUBCOVERAGE_FAILURE = 'UPDATE_TRIP_SUBCOVERAGE_FAILURE';

export const updateTripSubcoverageRequest = (subcoverageTripId, payload) => ({ type: UPDATE_TRIP_SUBCOVERAGE_REQUEST, payload: { subcoverageTripId, payload } });
export const updateTripSubcoverageSuccess = (data) => ({ type: UPDATE_TRIP_SUBCOVERAGE_SUCCESS, payload: data });
export const updateTripSubcoverageFailure = (error) => ({ type: UPDATE_TRIP_SUBCOVERAGE_FAILURE, payload: error });

export const DELETE_TRIP_FORECAST_NOT_TRIGGERED_REQUEST = 'DELETE_TRIP_FORECAST_NOT_TRIGGERED_REQUEST';
export const DELETE_TRIP_FORECAST_NOT_TRIGGERED_SUCCESS = 'DELETE_TRIP_FORECAST_NOT_TRIGGERED_SUCCESS';
export const DELETE_TRIP_FORECAST_NOT_TRIGGERED_FAILURE = 'DELETE_TRIP_FORECAST_NOT_TRIGGERED_FAILURE';

export const deleteTripForecastNotTriggeredRequest = (forecastNotTriggeredId) => ({ type: DELETE_TRIP_FORECAST_NOT_TRIGGERED_REQUEST, payload: forecastNotTriggeredId });
export const deleteTripForecastNotTriggeredSuccess = () => ({ type: DELETE_TRIP_FORECAST_NOT_TRIGGERED_SUCCESS });
export const deleteTripForecastNotTriggeredFailure = (error) => ({ type: DELETE_TRIP_FORECAST_NOT_TRIGGERED_FAILURE, payload: error });

export const DELETE_TRIP_CHECK_CLAIM_REQUEST = 'DELETE_TRIP_CHECK_CLAIM_REQUEST';
export const DELETE_TRIP_CHECK_CLAIM_SUCCESS = 'DELETE_TRIP_CHECK_CLAIM_SUCCESS';
export const DELETE_TRIP_CHECK_CLAIM_FAILURE = 'DELETE_TRIP_CHECK_CLAIM_FAILURE';

export const deleteTripCheckClaimRequest = (checkClaimId) => ({ type: DELETE_TRIP_CHECK_CLAIM_REQUEST, payload: checkClaimId });
export const deleteTripCheckClaimSuccess = () => ({ type: DELETE_TRIP_CHECK_CLAIM_SUCCESS });
export const deleteTripCheckClaimFailure = (error) => ({ type: DELETE_TRIP_CHECK_CLAIM_FAILURE, payload: error });



